<template>
    <div class="system" @click="openSelfCenter=false" v-if="noCommonRouter.indexOf($route.name)==-1">
        <top-logo @showSideBar="showSideBar" :tab="tab" :crumbs="crumbs" :storeData="storeData" :openSelfCenter="openSelfCenter" @changeSelfCenter="changeSelfCenter"></top-logo>
        <el-row type="flex" class="systemConBox" @click="showSideBar">
            <el-col :xs="5" :sm="5" :md="4" :lg="4" style="z-index:1" class="leftSidePart">
                <side-bar :storeData="storeData"></side-bar>
            </el-col>
            <el-col :xs="19" :sm="19" :md="20" :lg="20" class="mainPart">
                <keep-alive exclude="goodsBigScreen">
                    <router-view :curStoreId="curStoreId" :pageSize="pageSize" :storeData="storeData"></router-view>
                </keep-alive>
            </el-col>
        </el-row>
    </div>
    <div style="margin:0;padding:0;width:100vw;height:100vh;" v-else>
        <router-view :curStoreId="curStoreId" :pageSize="pageSize" :storeData="storeData"></router-view>
    </div>
</template>

<script type="text/javascript">
    import sideBar from '@/components/sideBar/sideBar.vue';
    import topLogo from '@/components/topLogo/topLogo.vue';
    import {url} from '@/router/url.js';
    import router from './../../router/index';
    export default{
        components: {sideBar, topLogo},
        data () {
            return {
                noCommonRouter:["bigScreenFrontEnd","bigScreenFrontEndWithoutAutoScreen","goodsBigScreen"],
                tab:0,
                curStoreId: '',
                pageSize: 10,
                crumbs:'',
                storeData: {}, // 当前店铺信息
                openSelfCenter: false, // 控制个人中心
            }
        },
        methods: {
            showSideBar: function ( data ) {
                let screenWidth = $(window).width();
                if ( parseInt($('.leftSidePart').css('left')) < 0 ) {
                    $('.leftSidePart').css({'left':0});
                } else {
                    if ( screenWidth <= 374 ) {
                        $('.leftSidePart').css({'left':'-45%'});
                    } else if ( screenWidth <= 570 ) {
                        $('.leftSidePart').css({'left':'-40%'});
                    } else if ( screenWidth <= 768 ) {
                        $('.leftSidePart').css({'left':'-30%'});
                    }
                }
            },
            changeSelfCenter: function ( data ) {
                this.openSelfCenter = !data;
            }
        },
        watch:{
            '$route':function (val) {
                this.crumbs =  val.name;
            }
        },
        created: function () {
            if(this.$route.name=='bigScreenFrontEnd'){
                this.curStoreId = this.$route.params['id'];
                return;
            }
            if ( !localStorage.getItem('token') ) {
                this.$router.push({path:'/login'});
            }
            console.log(this.$route)
            this.curStoreId = this.$route.params['id'];

            this.$http.get('/stores/'+this.curStoreId).then((res)=>{
                if(res.status == 200 ){
                    this.storeData = res.data
                        sessionStorage.setItem("call",JSON.stringify(res.data.call));
                        sessionStorage.setItem("isSettleCount",JSON.stringify(res.data.onlineEnabled));
                        sessionStorage.setItem("purchase",JSON.stringify(res.data.purchaseEnabled));
                        sessionStorage.setItem("rechargeLimit",JSON.stringify(res.data.rechargeLimit));
                        if(res.data.leaseProductEnabled){
                            sessionStorage.setItem("leaseProductEnabled",JSON.stringify(res.data.leaseProductEnabled));
                            try {
                                if(res.data.leaseEndDate){
                                    if(new Date().getTime()>new Date(res.data.leaseEndDate).getTime()){
                                        sessionStorage.setItem("leaseProductEnabled","false");
                                    }else{
                                        sessionStorage.setItem("leaseProductEnabled",JSON.stringify(res.data.leaseProductEnabled));
                                    }
                                }
                            } catch (error) {
                                
                            }
                        }else{
                            sessionStorage.setItem("leaseProductEnabled","false");
                        }
                }
            }).catch(err=>{
                console.log(err.response)
                if(err.response.status == 400){
                    this.$router.push({path:'/login'});
                    this.$message({
                        message: err.response.data,
                        customClass: 'error'
                    })
                }
            })
        },
        mounted: function () {
            if(this.$route.name=='bigScreenFrontEnd'){
                return;
            }
            this.tab++;
            $(document).ready(()=>{
                $('.system').on('click', ()=>{
                    let screenWidth = $(window).width();
                    if ( parseInt($('.leftSidePart').css('left')) <= 0 ) {
                        return;
                    }
                    if ( screenWidth <= 374 ) {
                        $('.leftSidePart').css({'left':'-45%'});
                    } else if ( screenWidth <= 570 ) {
                        $('.leftSidePart').css({'left':'-40%'});
                    } else if ( screenWidth <= 768 ) {
                        $('.leftSidePart').css({'left':'-30%'});
                    } else {
                        return;
                    }
                })
                $('.leftSidePart').on('touchend', ( e )=>{
                    e.stopPropagation();
                })
                $('.system').on('touchend', ( e )=>{
                    let screenWidth = $(window).width();
                    if ( screenWidth <= 374 ) {
                        $('.leftSidePart').css({'left':'-45%'});
                    } else if ( screenWidth <= 570 ) {
                        $('.leftSidePart').css({'left':'-40%'});
                    } else if ( screenWidth <= 768 ) {
                        $('.leftSidePart').css({'left':'-30%'});
                    } else {
                        return;
                    }
                });       
            })
            // 多标签
            //路由中meta标签的tabName为标签名
            router.beforeEach((to, from, next) => {
                if(to.meta.isKeep){
                    this.tab++;
                    console.log(to)
                    let obj = {
                        name:to.name,
                        path:to.path,
                        meta:to.meta
                    }
                    let tabNames = JSON.parse(sessionStorage.getItem("tabNames"));
                    if(tabNames){
                        // 判断当前是否已经有该标签
                        let flag = false;
                        for(let i=0;i<tabNames.length;i++){
                            if(tabNames[i].name == to.name){
                            flag = true;
                            break;
                            }
                        }
                        if(!flag){
                            tabNames.push(obj);
                            sessionStorage.setItem("tabNames",JSON.stringify(tabNames));
                        }
                    }else{
                        let tabNames = [];
                        tabNames.push(obj);
                        sessionStorage.setItem("tabNames",JSON.stringify(tabNames));
                    }
                }
                next();
            })
        }
    }
</script>
<style lang="scss">
    @import '../../../static/css/common.scss';
	@import "index";
    .mainPart{
        background-color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// index.vue?1a8c85ca